import { useEffect, useRef } from "react";
import "bootstrap/dist/css/bootstrap.min.css";
import { Container, Row, Col, Image } from "react-bootstrap";
import AwardsTopImage from "../../../assests/images/About-top-rated-awards-images/awards-top-image.webp";
import {
    TopRatedAwardSection,
    TopRatedAwardImagedWrap
} from "./awardsStyle";
import TopRatedAwardAbout from "./about";
import TopRatedAwardDetails from "./details";
import { useLocation } from "react-router-dom";
import TopRatedGuideBanner from "../../../components/common/topRatedGuideBanner";
import MetaComponent from "../../../components/common/metaComponent";

const TopRatedAward = () => {
    const location = useLocation();
    const qualifySectionRef = useRef<HTMLDivElement>(null);

    const scrollToQualify = () => {
        if (window.location.hash === '#qualify' && qualifySectionRef.current) {
            qualifySectionRef.current.scrollIntoView({ behavior: 'smooth' });
        }
  };

  useEffect(()=>{
        scrollToQualify();
  },[])
    return (
        <>
        <MetaComponent 
            keywords=""
            description=""
            ogTitle=""
            ogDescription=""
            ogUrl=""
            ogImage=""
        />
    <>
        <TopRatedAwardSection>
       
            <Container className="cont-w">
                <Row>
                    <Col lg="5" sm="12">
                         <TopRatedGuideBanner pathname={location.pathname === "/toprated/about"?"/detail-award":"/detail-award#qualify"} />
                    </Col>

                    <Col lg="7" sm="12">
                        <TopRatedAwardImagedWrap>
                            <Image src={AwardsTopImage} alt="Awards Top Image" />
                        </TopRatedAwardImagedWrap>
                    </Col>
                </Row>
            </Container>
        </TopRatedAwardSection>
        {location.pathname === "/toprated/about" && <TopRatedAwardAbout />}
        {location.pathname === "/detail-award" && <TopRatedAwardDetails qualifySectionRef={qualifySectionRef}/>}
       
    </></>)
};
export default TopRatedAward;